import Vue from 'vue';
import mobile from 'is-mobile';

const STORAGE_COUNT = 'pcount';


const store = Vue.observable({
  eventConfig: null,

  vendor: '',
  eventId: '',
  shortEventId: '',

  mediaId: '',
  mediaUrl: '',

  largeScreenLayout: window.screen.width >= 700,
  isMobile: mobile({
    tablet: true,
    featureDetect: true,
  }),
  uploadCount: 0,
});

export default store;


/*
Causes error in slider init

let debounceResize = null;

window.addEventListener('resize', () => {
  clearTimeout(debounceResize);
  debounceResize = setTimeout(() => {
    store.largeScreenLayout = window.screen.width >= 700;
  }, 200);
});
*/

/**
 */
export function incrementCount() {
  store.uploadCount += 1;

  try {
    Vue.$cookies.set(STORAGE_COUNT, `${store.uploadCount}`);
  } catch (err) {
    console.error(err);
  }
  try {
    localStorage.setItem(STORAGE_COUNT, `${store.uploadCount}`);
  } catch (err) {
    console.error(err);
  }

  return store.uploadCount;
}


function getCount() {
  let storageCount = 0;
  let cookieCount = 0;
  let count = 0;

  try {
    cookieCount = Number(Vue.$cookies.get(STORAGE_COUNT)) || 0;
  } catch (err) {
    console.error(err);
  }
  try {
    storageCount = Number(localStorage.getItem(STORAGE_COUNT)) || 0;
  } catch (err) {
    console.error(err);
  }

  count = cookieCount;

  if (storageCount > count) {
    count = storageCount;
  }

  return count;
}

/**
 */
export function init() {
  store.uploadCount = getCount();
}


/**
 */

export function getLayout(layoutId) {
  const {
    categories,
  } = store.eventConfig;


  for (let i = 0; i < categories.length; i += 1) {
    const category = categories[i];

    for (let j = 0; j < category.layouts.length; j += 1) {
      const layout = category.layouts[j];

      if (layout.id === layoutId) {
        return layout;
      }
    }
  }


  return null;
}
